import React from 'react';
import { hsbToHex, ColorPicker as ColorPicker$1 } from '@shopify/polaris';
import styles from './ColorPicker.scss.mjs';
import { TextPicker } from './components/TextPicker/TextPicker.mjs';
import { hexToHsb } from '../../utilities/color/color.mjs';

function ColorPicker({
  color: hsbColor,
  onChange
}) {
  const color = hsbToHex(hsbColor);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ColorPicker
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.TopContainer
  }, /*#__PURE__*/React.createElement(ColorPicker$1, {
    color: hsbColor,
    onChange: onChange
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.MiddleContainer
  }, /*#__PURE__*/React.createElement(TextPicker, {
    color: color,
    onChange: handleHexColorChange
  })));
  function handleHexColorChange(hex) {
    onChange(hexToHsb(hex));
  }
}

export { ColorPicker };
